export enum RefreshIdentifier {
    notification = 'Notification',
    vnetPeerStatus = 'VnetPeerStatus',
    vmStatus = 'VmStatus',
    allVmStatus = 'AllVmStatus',
    allSubscriptions = 'AllSubscriptions',
    subscriptionVMs = 'SubscriptionVms'
}
